/**
 * Created by filatov on 15.09.2015.
 */
import LeaveCSVPreviewBalanceColumnsRender from './LeaveCSVPreviewBalanceColumnsRender'
import LeaveCSVPreviewColumnsStrategy from './LeaveCSVPreviewColumnsStrategy'

export default function LeaveCSVPreviewTimeAndBalancesStrategy() {}

LeaveCSVPreviewTimeAndBalancesStrategy.prototype = new LeaveCSVPreviewColumnsStrategy();

LeaveCSVPreviewTimeAndBalancesStrategy.prototype.init = function ( balanceQualifier )
{
    LeaveCSVPreviewColumnsStrategy.prototype.init.call( this );
    this.balanceColumnsRender = new LeaveCSVPreviewBalanceColumnsRender().init(balanceQualifier);

    return this;
};

LeaveCSVPreviewTimeAndBalancesStrategy.prototype.getNumOfDataColumns = function ()
{
    return 2 + this.balanceColumnsRender.getNumberOfDataBalancesCells();
};

LeaveCSVPreviewTimeAndBalancesStrategy.prototype.addMainHeaderRowCells = function ( mainHeaderRow )
{
    this.addLeaveTypeTotalCell(mainHeaderRow);
    this.addLeaveTypeCell(mainHeaderRow);
    this.balanceColumnsRender.addHeaderBalancesCells(mainHeaderRow);
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/leave/LeaveCSVPreviewTimeAndBalancesStrategy.js